import React from "react";
import { C } from "../core/constants";
import { analyticsWindowLabelKey } from "../core/analyticsWindows";

export default function AnalyticsWindowSelector({
  windowKey,
  options,
  onChange,
  loading = false,
  disabled = false,
  hasData = true,
  showLoadingHint = false,
  acc,
  t,
}) {
  const isBusy = loading && hasData;
  const isDisabled = disabled || isBusy;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        marginBottom: 16,
        opacity: isBusy ? 0.85 : 1,
      }}
    >
      <div style={{ display: "inline-flex", border: `1px solid ${acc.primary}33`, borderRadius: 999, overflow: "hidden" }}>
        {options.map((id) => {
          const active = id === windowKey;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onChange(id)}
              disabled={isDisabled}
              style={{
                border: "none",
                padding: "8px 14px",
                cursor: isDisabled ? "not-allowed" : "pointer",
                background: active ? `${acc.primary}22` : "transparent",
                color: active ? C.textPrimary : C.textSecondary,
                fontSize: 12,
              }}
            >
              {t(analyticsWindowLabelKey(id))}
            </button>
          );
        })}
      </div>
      {showLoadingHint && isBusy && (
        <div style={{ marginTop: 8, fontSize: 12, color: C.textMuted }}>
          {t("credits_insights_loading")}
        </div>
      )}
    </div>
  );
}
